export default __webpack_public_path__ + "static/media/ADVIKA_pdf3.bcf5c3bd.pdf";